import React from 'react';

import { Grid, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { SalesOrderList } from '../../features/salesOrder/components/SaleOrderList';

export const SalesOrderListPage = (): JSX.Element => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<Layout>
			<Grid container paddingY={isMobile ? 2 : 5} justifyContent={'center'}>
				<Grid
					item
					xs={12}
					sx={{
						ml: isMobile ? 2 : 20,
						mb: isMobile ? 2 : 0,
					}}
				>
					<Typography
						variant={isMobile ? 'h5' : 'h4'}
						sx={{
							fontWeight: 500,
							textAlign: isMobile ? 'left' : 'left',
							fontSize: isMobile ? '1.5rem' : '2.125rem',
						}}
					>
						Ordenes de venta
					</Typography>
				</Grid>
				<Grid paddingY={isMobile ? 2 : 5}>
					<SalesOrderList />
				</Grid>
			</Grid>
		</Layout>
	);
};
